import { clsx } from 'clsx';

// Provider identity is the provider's name on a neutral accent-tag tile —
// d2d's palette is monochrome-violet, so no brand-coloured fills. Shared by
// Cloud Providers (lg) and the AWS, Azure, GCP and Hetzner resource pages
// (design evaluation F41).
export default function ProviderMark({ label, size = 'md' }: { label: string; size?: 'md' | 'lg' }) {
  return (
    <span
      aria-hidden
      className={clsx(
        'flex flex-none items-center justify-center rounded-lg bg-[var(--accent-tag-bg)] font-semibold text-[var(--accent-tag-text)]',
        size === 'lg' ? 'h-12 w-12 text-sm' : 'h-10 w-10 text-micro',
      )}
    >
      {label}
    </span>
  );
}
